var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ColorCodeService } from "../../../services/color-code.service";
import { UserService } from "../../../services/user.service";
import { CardComponent } from "../card.component";
var ResourceFeaturedCardComponent = /** @class */ (function (_super) {
    __extends(ResourceFeaturedCardComponent, _super);
    function ResourceFeaturedCardComponent(colorCodeService, userService) {
        var _this = _super.call(this, colorCodeService, userService) || this;
        _this.colorCodeService = colorCodeService;
        _this.userService = userService;
        _this.headerURL = null;
        return _this;
    }
    ResourceFeaturedCardComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
        return false;
    };
    return ResourceFeaturedCardComponent;
}(CardComponent));
export { ResourceFeaturedCardComponent };
